import React from "react";
import Navbar from "../Navbar";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="flex flex-col items-center min-h-screen bg-[#F8F6F0] p-10">
        <br />
        <div className=" lg:w-[60%] sm:w-[80%] flex justify-center flex-col items-center lg:mt-20">
          <h3 className="text-lg underline">About Us</h3>

          <p className="text-justify mt-2">
            Welcome to Maa Ooru Bomma, a heartfelt initiative to celebrate the rich tradition of Indian handicrafts and the stories they tell. Inspired by the vibrant culture of our roots, our platform showcases the timeless art of handcrafted toys, carefully created by skilled artisans across India.
            <br />
            <br />
            Each piece on our platform is a testament to the legacy of traditional craftsmanship, reflecting the passion and dedication of artisans who pour life into wood, clay, and other natural materials. From Kondapalli toys of Andhra Pradesh to the intricate wooden carvings of Rajasthan, we aim to bring the essence of every region to your home.
            <br />
            <br />
            At Maa Ooru Bomma, we are committed to preserving these age-old art forms, supporting local artisans, and spreading the joy of owning something truly authentic. With every purchase, you’re not just taking home a handcrafted treasure—you’re becoming a part of the journey to keep this heritage alive.
            <br />
            <br />
            Thank you for being a part of our mission. Together, let’s celebrate the beauty of India’s craft traditions.</p>
        </div>
      </div>
      <div className="bg-primary text-gray-500 w-full flex flex-col-reverse lg:grid lg:grid-cols-3 p-3 justify-items-center">
        <div className="hidden lg:block"></div>
        <div className="w-full flex flex-col items-center justify-center">
          <p>

            <span className="text-xs mx-2">maoorubomma.com</span>
          </p>
          <p className="text-xs">&copy;2025 "All Right Reserved" </p>
        </div>
        <div className="w-full my-2 flex items-center justify-center space-x-3">
          <FacebookRoundedIcon fontSize="large" />
          <InstagramIcon fontSize="large" />
        </div>
      </div>
    </>
  );
};

export default AboutPage;
